import { hexColor, View } from "@lightningtv/solid";
import { createSignal, Show } from "solid-js";

export function DeleteButton(props: any) {
    const [focused, setFocused] = createSignal(false);
    return (
        <View
            ref={props.ref}          // ← ADD THIS
            x={props.x} y={props.y}
            width={50} height={50}
            borderRadius={25}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onEnter={props.onEnter}
            onLeft={props.onLeft}    // ← ADD THIS
        >
            <Show when={focused()}>
                <View
                    x={-2} y={-2}
                    width={54} height={54}
                    borderRadius={27}
                    color={hexColor("#2563eb")}
                    zIndex={-1}
                />
            </Show>
            <View
                x={0} y={0}
                width={50} height={50}
                borderRadius={25}
                color={hexColor("#1f2937")}
            >
                <View x={10} y={10} width={30} height={30} src="https://i.ibb.co/w690c1G/recycle-bin.png" />
            </View>
        </View>
    );
}